import AnalyticsHelper from '../utils/analytics-helper';
export default class FullScreen {
    constructor(el, parent) {
        this.el = el;
        this.parent = parent;
        this.body = document.querySelector('body');
        this.fullScreen = document.querySelector('.full-screen');
        this.bind();
    }

    bind() {
        if (this.fullScreen) {
            this.fullScreen.addEventListener('click', (e) => {
                if (
                    document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement
                ) {
                    const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
                    if (exitFullscreen) {
                        exitFullscreen.call(document).catch((err) => console.error('Unable to exit fullscreen', err));
                    }
                } else if (this.body.requestFullscreen) {
                    this.body.requestFullscreen().catch((err) => console.error('Unable to enter fullscreen', err));
                } else if (this.body.webkitRequestFullscreen) {
                    this.body.webkitRequestFullscreen().catch((err) => console.error('Unable to enter fullscreen', err));
                } else if (this.body.msRequestFullscreen) {
                    this.body.msRequestFullscreen().catch((err) => console.error('Unable to enter fullscreen', err));
                }
            });
            const handleFullscreenChange = () => {
                if (
                    document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement
                ) {
                    this.fullScreen.classList.add('full-screen-open');
                    this.analyticsPush();
                } else {
                    this.fullScreen.classList.remove('full-screen-open');
                }
                this.fullScreen.focus();
                this.parent.updatePanoHfov();
            };
            this.body.addEventListener('fullscreenchange', handleFullscreenChange);
            this.body.addEventListener('webkitfullscreenchange', handleFullscreenChange);
            this.body.addEventListener('MSFullscreenChange', handleFullscreenChange);
        }
    }

    analyticsPush() {
        const model = this.parent.params.get('model');
        const { stepNumber, stepName } = this.parent;

        window.dataLayer.push({
            event: '360 Configurator',
            eventCategory: 'Car Configurator',
            eventAction: 'loaded-fullscreen',
            eventLabel: `cars|${model}|configurator|Step ${stepNumber}. ${stepName}|Full Screen|internal|top|#`,
            actionType: 'loaded-fullscreen',
            businessUnit: 'cars',
            moduleName: 'configurator',
            clickText: 'Full Screen',
            clickType: 'internal',
            destinationURL: '#',
            configuratorStepName: `Step ${stepNumber}. ${stepName}`,
            modelSelected: `${model}`,
            inPageLocation: 'top',
        });
    }
}
